import { Button, Dialog, DialogClose, DialogContent, DialogTitle } from '@monksflow/monks-ui';
import { XIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { ModalProps } from './Modal.types';

export const Modal = ({ open, onClose, children }: ModalProps) => {
  const { t } = useTranslation('common');

  return (
    <Dialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) onClose();
      }}
    >
      <DialogContent
        data-testid="modal"
        className="max-w-148 gap-0 bg-background/90 p-4"
        overlayClassName="bg-foreground/10 backdrop-blur-3xl"
        showCloseButton={false}
      >
        {/* Callers own the visible heading, so the accessible name is generic rather than absent. */}
        <DialogTitle className="sr-only">{t('components.modal.dialog')}</DialogTitle>
        <div className="flex flex-row justify-end">
          <DialogClose asChild>
            <Button
              variant="ghost"
              size="icon"
              aria-label={t('components.modal.close')}
              data-testid="modal-close-btn"
            >
              <XIcon />
            </Button>
          </DialogClose>
        </div>
        {children}
      </DialogContent>
    </Dialog>
  );
};
